import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Modal from 'react-modal';
import { useState } from 'react';

export default function Card(props) {
  const [showModal, setShowModal] = useState(false);
  const [isMdBreakpoint, setIsMdBreakpoint] = useState(false);

  useEffect(() => {
    Aos.init({ once: true, offset: 50, duration: 500, delay: 100, easing: 'ease-in-out' });
  }, [showModal]);

  useEffect(() => {
    const handleResize = () => {
      setIsMdBreakpoint(window.innerWidth >= 768);
    };

    handleResize(); // Check on initial render

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleClick = () => {
    setShowModal(true);
    Aos.refresh(); // Add this line to trigger the animation
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const modalStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: '80',
    },
    content: {
      marginLeft: isMdBreakpoint ? '300px' : '0',
    },
  };

  return (
    <>
      {showModal && 
          <Modal className="" id='mymodal' isOpen={showModal} onRequestClose={handleCloseModal} style={modalStyles}
          >
            <div className='flex flex-col justify-center space-y-4'>
              <div className='flex flex-row justify-between'>
                <div className='text-3xl'>Project</div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3.0} stroke="#7f7f7f" className="h-4 w-4 m-4 z-90 hover:cursor-pointer hover:stroke-black relative bottom-4 left-4" onClick={handleCloseModal}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
              </div>
              <div className='flex flex-col items-center justify-center space-y-4 p-4'>
                <img className='h-44 w-96' src={props.path} alt="" />
                <div>
                  {props.desc}
                </div>
              </div>
              <div className='flex flex-row space-x-2 text-white'>
                <a href={`${props.repo}`} target="_blank" rel="noopener noreferrer" className='bg-[#17a2b8] p-2'>Project</a>
                <a href={`${props.repo}`} target="_blank" rel="noopener noreferrer" className='bg-[#17a2b8] p-2'>Report</a>
              </div>
            </div>
          </Modal>
      }
      <div data-aos="zoom-in-up" className='flex flex-col items-center group hover:cursor-pointer space-y-2' onClick={handleClick} onHover={() => props.onHover("projects")}>
          
          <div className='bg-black relative'>
              <img className='hover:opacity-50 h-64 md:h-44 w-[500px] md:w-96 group-hover:opacity-20' src={props.path} alt="" />

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.0} stroke="currentColor" className="h-16 w-16 text-gray-400 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden group-hover:block">
                  <path strokeLinecap="" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>

          </div>
        
          <span className=''>{props.title}</span>

      </div>
    </>
  )
}
